/* Featured testimonials (PREVIEW TEST) — selection, crossfade, thumb paging,
   mobile read-more. Self-contained, one instance per [data-ft-root]. */
(function () {
  function initRoot(root) {
    if (root.__ftInit) return;
    root.__ftInit = true;

    var medias = Array.prototype.slice.call(root.querySelectorAll('[data-ft-media]'));
    var quotes = Array.prototype.slice.call(root.querySelectorAll('[data-ft-quote]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ft-thumb]'));
    var viewport = root.querySelector('.ft-thumbs__viewport');
    var prev = root.querySelector('[data-ft-prev]');
    var next = root.querySelector('[data-ft-next]');
    var active = 0;
    var mobileMQ = window.matchMedia('(max-width: 879px)');

    function updateMore(quote) {
      if (!quote) return;
      var body = quote.querySelector('[data-ft-clamp]');
      var more = quote.querySelector('[data-ft-more]');
      if (!body || !more) return;
      if (quote.classList.contains('is-expanded')) { more.hidden = false; return; }
      var clampable = mobileMQ.matches && (body.scrollHeight - body.clientHeight > 4);
      more.hidden = !clampable;
    }

    function setActive(i) {
      if (i < 0 || i >= Math.max(medias.length, quotes.length, thumbs.length)) return;
      active = i;
      medias.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
      quotes.forEach(function (el, idx) {
        var on = idx === i;
        el.classList.toggle('is-active', on);
        if (!on) {
          el.classList.remove('is-expanded');
          var m = el.querySelector('[data-ft-more]');
          if (m) m.textContent = '+ Read more';
        }
      });
      thumbs.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });

      var activeThumb = thumbs[i];
      if (activeThumb && viewport) {
        // Centre the active thumb within the strip (scrolls only the strip, no page jump).
        var tb = activeThumb.getBoundingClientRect();
        var vb = viewport.getBoundingClientRect();
        var delta = (tb.left - vb.left) - (vb.width - tb.width) / 2;
        viewport.scrollBy({ left: delta, behavior: 'smooth' });
      }
      // Defer clamp measurement until the quote is visible/laid out.
      requestAnimationFrame(function () { updateMore(quotes[i]); });
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () { setActive(idx); });
    });

    quotes.forEach(function (q) {
      var more = q.querySelector('[data-ft-more]');
      if (!more) return;
      more.addEventListener('click', function () {
        var expanded = q.classList.toggle('is-expanded');
        more.textContent = expanded ? '– Show less' : '+ Read more';
        updateMore(q);
      });
    });

    var total = Math.max(medias.length, quotes.length, thumbs.length);

    // Arrows step to the prev/next FEATURE (wrap-around). setActive() then
    // re-centres the thumbnail strip on the active person.
    if (prev) prev.addEventListener('click', function () { setActive((active - 1 + total) % total); });
    if (next) next.addEventListener('click', function () { setActive((active + 1) % total); });

    // Mobile: size thumbnails so exactly 3 full ones fit the strip viewport.
    var thumbsEl = root.querySelector('[data-ft-thumbs]');
    function fitThumbs() {
      if (!viewport || !thumbsEl) return;
      if (mobileMQ.matches) {
        // Mobile: size thumbnails so 3 full ones fit the strip (bigger thumbs).
        var gap = 10, trackPad = 4; // matches mobile .ft-thumbs__track gap + padding
        var size = Math.floor((viewport.clientWidth - trackPad - gap * 2) / 3);
        if (size > 0) thumbsEl.style.setProperty('--ft-thumb-size', size + 'px');
      } else {
        // Desktop: fall back to the fixed CSS size (108px).
        thumbsEl.style.removeProperty('--ft-thumb-size');
      }
    }

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () { fitThumbs(); updateMore(quotes[active]); }, 150);
    });
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', fitThumbs);

    fitThumbs();
    setActive(0);
    window.addEventListener('load', fitThumbs);
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-ft-root]')).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
